export default __webpack_public_path__ + "assets/images/a8f8c15fc1923ea6367aa33a0cc48db2.png";